import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import ConnectionBanner from "@/components/ConnectionBanner";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const mobileLayerRef = useRef(null);
  const location = useLocation();
  useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!mobileNavOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    mobileLayerRef.current?.querySelector('button[aria-label="Close navigation"]')?.focus();
    const onKey = event => {
      if (event.key === "Escape") setMobileNavOpen(false);
      if (event.key === "Tab") {
        const focusable = [...(mobileLayerRef.current?.querySelectorAll('a,button,select,[tabindex]:not([tabindex="-1"])') || [])];
        if (!focusable.length) return;
        const first = focusable[0]; const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = previousOverflow; };
  }, [mobileNavOpen]);

  return <div className="manager-ui app-shell">
    <Sidebar />
    {mobileNavOpen && <div className="app-mobile-nav-layer" ref={mobileLayerRef} role="dialog" aria-modal="true" aria-label="Navigation menu"><button className="app-mobile-nav-backdrop" onClick={() => setMobileNavOpen(false)} aria-label="Close navigation overlay" tabIndex={-1} /><Sidebar mobile onClose={() => setMobileNavOpen(false)} /></div>}
    <div className="app-main-column">
      <Topbar onOpenNavigation={() => setMobileNavOpen(true)} />
      <ConnectionBanner />
      <main className="app-page" id="main-content">{children}</main>
    </div>
    <Toaster theme="light" position="top-right" toastOptions={{ style: { background: "#fff", color: "#20303a", border: "1px solid #dfe7eb", borderRadius: 10, fontFamily: "Inter, system-ui, sans-serif" } }} />
  </div>;
}
